import * as types from './userActionTypes.js';

export const setUserToken = (userToken) => ({ type: types.SET_USERTOKEN, userToken: userToken });
export const setUserInfo = (userInfo) => ({type: types.SET_USERINFO, userInfo: userInfo});